module.exports = __webpack_public_path__ + "assets/images_base/label-premium.svg?v=6d6bb2d9";